export const BAD_REQUEST = 400;
export const UNAUTHORIZED = 401;
export const FORBIDDEN = 403;
export const REQUEST_ENTITY_TOO_LARGE = 413;
export const INTERNAL_SERVER_ERROR = 500;
export const LOCKED = 423;
export const PRECONDITION_REQUIRED = 428;
export const TOO_MANY_REQUESTS = 429;
